/* eslint-disable max-lines */
import React, { useCallback, useEffect, useState } from 'react';

import i18n from 'i18n-react';
import { HashLink as Link } from 'react-router-hash-link';
import { Spring } from 'react-spring';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import BackVideo from 'components/BackVideo';
import LanguageSelect from 'components/LanguageSelect';
import SearchInput from 'components/SearchModal/SearchInput';
import StoreButtons from 'components/StoreButtons';
import NotificationSlider from 'components/NotificationSlider';

import APIHandler from 'config/APIHandler';
import DataHandler from 'config/DataHandler';
import StorageHandler from 'config/StorageHandler';

import { useSettings } from 'hooks/useSettings';
import { useUserInfo } from 'hooks/useUserInfo';


import { bgVideo, storageKeys } from 'settings';
import GlassWidgetPanel from 'components/GlassCardsLegacy';

/**
 * Landing page for the application.
 *
 * @returns {JSX.Element} HomeView component
 */
const HomeView = () => {
  const [message, setMessage] = useState({});
  const { appId = -1, appInfo: { logoWhite } = {} } = useSettings();
  const { user = {} } = useUserInfo();
  const { first_name: firstName, last_name: lastName, email } = user;

  // If the salescompanion has not been registered yet for user (sales_companion_registered === null), this function will register the current date as the registration date.
  const registerSalesCompanion = useCallback(async () => {
    const { sales_companion_registered: salesCompanionRegistered } = user || {};

    if (user && salesCompanionRegistered === null) {
      const obj = user;
      const d = new Date(Date.now());
      const leading = (val) => `0${val}`.slice(-2);
      const date = `${d.getFullYear()}-${leading(d.getMonth() + 1)}-${leading(d.getDate())}`;

      const res = await APIHandler.updateUser(appId, obj.email, [{ param: 'sales_companion_registered', val: date }]);

      if (res) {
        obj.sales_companion_registered = date;
        StorageHandler.save(storageKeys.user, obj);
      }
    }
  }, [appId, user]);

  useEffect(() => {
    document.body.classList.add('no-scroll');

    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, []);

  useEffect(() => {
    registerSalesCompanion();
  }, [registerSalesCompanion]);


  const setAnnouncements = useCallback(async () => {
    StorageHandler.load(storageKeys.lang).then(async (langCode) => {
      const res = await APIHandler.getContests(appId, {
        currentDate: new Date().toISOString(),
        marketFilter: [{ id: langCode.code.toUpperCase() }],
      });

      // If there are messages returned, register the formatted information to the toast.
      if (res.length !== 0 && res && res[0].title) {
        const { summary } = res[0];

        // Convert to month / day format
        const message = `<p><b>${summary}</b></p>`;

        setMessage({ id: res[0].id, message, weblink: '/main/rewards', type: 'message' });

      }
    });
  }, [appId]);

  useEffect(() => {
    setAnnouncements();
  }, [setAnnouncements]);


  return (
    <div className="homeContainer">
      {bgVideo && <BackVideo />}
      <div className="homeView__buttonWrapper--download-app">
        {i18n.translate('homeScreen.downloadNow')}
        <StoreButtons />
      </div>
      <LanguageSelect />
      <Spring from={{ transform: 'translateY(50%)', opacity: 0 }} to={{ transform: 'translateY(0%)', opacity: 1 }}>
        {(props) => (
          <div className="homeView" style={props}>
            <div className="homeView__title">
              <img src={logoWhite} className="homeLogo" alt="logo" />
              <div className="homeView__title--action">
                <SearchInput />
                <div className="homepage__buttons homepage__buttons--main">
                  <Link to="/main/rewards" className="startTrain startTrain--red">
                    <FontAwesomeIcon icon={['fas', 'treasure-chest']} />
                    <p>{i18n.translate('nav.rewards')}</p>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        )}
      </Spring>
      <div className="top-bar" />
      <div className="bottom-bar" />
      {/* <SweetAlert
          title="This feature is Coming Soon"
          show={noAgent}
          imageUrl={Logo2}
          imageWidth="50rem"
          imageHeight="50rem"
          html
          text=""
          customClass="noAgent"
          showConfirmButton={false}
          cancelButtonText={i18n.translate('general.close')}
          showCancelButton
          onConfirm={close}
          onCancel={close}
          onEscapeKey={close}
          onOutsideClick={close}
        /> */}
      <GlassWidgetPanel appId={appId}
        position="right"
        firstName={firstName}
        lastName={lastName}
        email={email}
      />
    </div>
  );
};

export default HomeView;
